module.exports = __webpack_public_path__ + "img/plane_track_mobile_3.e90471cb.svg";